import { EBalconyType, JsonQuery } from '@/packages/JsonQuery';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagBalconySchema } from '../types';

const TEXT_MAP: { [key in EBalconyType]: string } = {
  [EBalconyType.Balcony]: 'Есть балкон',
  [EBalconyType.Loggia]: 'Есть лоджия',
};

export const balcony: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = new JsonQuery(jsonQuery).getBalconyTypes() || [];

    const tagsGroup: TagBalconySchema[] = value.map(key => ({
      group: 'balcony',
      text: TEXT_MAP[key],
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagBalconySchema) {
    const currentValue = new JsonQuery(jsonQuery).getBalconyTypes() || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setBalconyTypes',
      arguments: [nextValue],
    });
  },
};
